export default "__VITE_PUBLIC_ASSET__a40cf88a__"